import {
  getFocusStyle,
  getTheme,
  ICalendarDayProps,
  ITheme,
  mergeStyleSets,
} from "@fluentui/react";
import { ITheme as CayoTheme, themeUtils } from "cayo.ui";
import styled from "styled-components";
import { Row } from "@cayo/shared/components/CommonLayout";

const theme: ITheme = getTheme();
const { palette, semanticColors, fonts } = theme;

export const classNames = mergeStyleSets({
  container: {
    overflow: "auto",
    maxHeight: 500,
    minWidth: 400,
  },
  itemCell: [
    getFocusStyle(theme, { inset: -1 }),
    {
      minHeight: 40,
      padding: "0px 10px",
      boxSizing: "border-box",
      borderBottom: `1px solid ${semanticColors.bodyDivider}`,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      whiteSpace: "nowrap",
      selectors: {
        "&:hover": { background: palette.neutralLight },
      },
    },
  ],
  itemCellSelected: [
    getFocusStyle(theme, { inset: -1 }),
    {
      minHeight: 40,
      padding: "0px 10px",
      boxSizing: "border-box",
      background: palette.themePrimary,
      color: palette.white,
      borderBottom: `1px solid ${semanticColors.bodyDivider}`,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
  ],
  itemImage: {
    flexShrink: 0,
  },
  itemContent: {
    marginLeft: 10,
    overflow: "hidden",
    flexGrow: 1,
  },
  itemName: [
    fonts.xLarge,
    {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  ],
  itemIndex: {
    fontSize: fonts.small.fontSize,
    color: palette.neutralTertiary,
    marginBottom: 10,
  },
  chevron: {
    alignSelf: "center",
    marginLeft: 10,
    color: palette.neutralTertiary,
    fontSize: fonts.large.fontSize,
    flexShrink: 0,
  },
  callout: {
    minWidth: 300,
  },
  buttonArea: {
    verticalAlign: "top",
    display: "inline-block",
    textAlign: "center",
    minWidth: 130,
    height: 32,
  },
  optionsList: {
    minWidth: "100px",
    height: "100%",
  },

  calendarsWrapper: {
    alignItems: "stretch",
  },
  calendar: {
    justifyContent: "space-between",
  },
});

export const calendarDayProps: Partial<ICalendarDayProps> = {
  styles: {
    dayCell: {
      // styles for dayCell when today
      ":has(.ms-CalendarDay-dayIsToday)": {
        backgroundColor: palette.neutralLight,
        color: palette.neutralPrimary,
        borderRadius: "unset",
        border: `1px solid ${palette.neutralSecondary}`,
        "> button": {
          backgroundColor: "transparent !important",
          color: `${palette.neutralPrimary} !important`,
        },
      },
      // styles for dayCell when selected
      "&.ms-CalendarDay-daySelected": {
        backgroundColor: "transparent !important",
        "&::before": {
          border: "none !important",
        },
        "> button": {
          borderRadius: "50%",
          backgroundColor: palette.themePrimary,
          color: palette.white,
          fontWeight: 600,
        },
        // styles for dayCell when today + selected
        ":has(.ms-CalendarDay-dayIsToday)": {
          backgroundColor: `${palette.neutralLight} !important`,
          "> button": {
            backgroundColor: `${palette.themePrimary} !important`,
            color: `${palette.white} !important`,
          },
        },
      },
    },
  },
};

export const BlankSpace = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 1;
  background: ${themeUtils.addAlpha("#FFFFFF", 0.5)};
`;

export const IntervalWrapper = styled(Row)`
  padding: 10px;
  margin-top: 12px;
  border-top: 1px solid ${(props) => (props.theme as CayoTheme).cayoTheme.brandColors.divider};
`;
